import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3c2ac187&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3c2ac187&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2ac187",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c2ac187')) {
      api.createRecord('3c2ac187', component.options)
    } else {
      api.reload('3c2ac187', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3c2ac187&scoped=true&lang=pug", function () {
      api.rerender('3c2ac187', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/console/consultant/classRecords/vipAnalysisTable/vipField/index.vue"
export default component.exports